import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Switch from '../../../../../../../Shared/Switch';
import { ErrorMessage } from '../../../../../../../Services/styled-components';
import { EditableQuestion } from '../../../../../types';
import { StyledQuestionFieldContainer } from '../../styles';
import { validateAnswerSelection } from './validation';
import { selectBlockingAnswers } from '../../../../../../../../redux/questionnaire/selectors';

interface Props {
  control: Control<EditableQuestion>;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const AnswerSelectionSwitch = ({ control, checked, onChange }: Props) => {
  // Blocking answers live in redux rather than on the question, so the rule reads them
  // here and the validator stays a plain function of what it is given.
  const blockingAnswers = useSelector(selectBlockingAnswers);

  return (
    <StyledQuestionFieldContainer>
      <Switch
        label="Hide answer selection"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)}
        checked={checked}
        disabled={false}
        reverseOrder={false}
      />
      <Controller
        name="answer_selection"
        control={control}
        rules={{ validate: (value, question) => validateAnswerSelection(value, question, blockingAnswers) }}
        render={({ fieldState }) => <ErrorMessage>{fieldState.error?.message}</ErrorMessage>}
      />
    </StyledQuestionFieldContainer>
  );
};

export default AnswerSelectionSwitch;
